var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"hidden lg:block w-64 px-4"},[_c('h5',{staticClass:"text-sm font-medium text-gray-600 mb-2"},[_vm._v(" Project • "),(_vm.project)?_c('RouterLink',{staticClass:"text-blue-700",attrs:{"to":{
        name: 'accounts.projects.project',
        params: {
          accountId: _vm.contactRequest.accountId,
          projectId: _vm.contactRequest.projectId,
        },
      }}},[_vm._v(" Open Project ")]):_vm._e()],1),_c('div',{staticClass:"flex-none py-1 text-gray-900 leading-6 truncate"},[_vm._v(" "+_vm._s(_vm.project ? _vm.project.name : 'No Project')+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }